import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { syncGames } from '../../services'
import { GameSyncResponse } from '@/modules/game/type'

export const useMutationGameSync = (
	props: UseMutationOptions<GameSyncResponse>,
) => {
	return useMutation({
		mutationFn: syncGames,
		...props,
	})
}
